$('.video-iframe').on('click', function () {
		const $video = $(this);
		const videoClass = $video.attr('data-classes');
		const videoSrc = $video.attr('data-video-src');
		const videoWidth = $video.attr('data-width');
		const videoHeight = $video.attr('data-height');
		const videoTitle = $video.attr('data-title');

		$video.replaceWith(`
				<iframe class="${videoClass}" loading="lazy" width="${videoWidth}" height="${videoHeight}"
				src="${videoSrc}?autoplay=1"
				title="${videoTitle}" frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				allowfullscreen></iframe>
			`)
});